import { useLingui } from '@lingui/react/macro'
import { Button } from 'designSystem/components/Button'
import type { MetadataEditSurface } from 'features/knowledgeDocumentViewer/components/metadata/ChooseEditScopePanel'
import {
  getScopeChoiceCopy,
  ScopeSummaryCard,
} from 'features/knowledgeDocumentViewer/components/metadata/ScopeSummaryCard'
import type { MetadataEditScope } from 'features/knowledgeDocumentViewer/types/metadataEditScope'
import { FileStack, FileText } from 'lucide-react'
import React, { useCallback } from 'react'

export type ActiveEditScopeBannerProps = {
  editScope: MetadataEditScope
  familySize: number
  currentFilename?: string
  metadataSurface?: MetadataEditSurface
  onChangeScope: () => void
}

export function ActiveEditScopeBanner({
  editScope,
  familySize,
  currentFilename,
  metadataSurface = 'page',
  onChangeScope,
}: ActiveEditScopeBannerProps): React.ReactElement {
  const { t } = useLingui()
  const handleChange = useCallback(() => {
    onChangeScope()
  }, [onChangeScope])

  const copy = getScopeChoiceCopy({
    scope: editScope,
    familySize,
    metadataSurface,
    currentFilename,
  })

  return (
    <ScopeSummaryCard
      icon={
        editScope === 'family' ? (
          <FileStack size={20} />
        ) : (
          <FileText size={20} />
        )
      }
      title={copy.title}
      description={copy.description}
      action={
        <Button
          type='button'
          variant='ghost'
          size='default'
          aria-label={t`Change edit scope`}
          onClick={handleChange}>
          {t`Change`}
        </Button>
      }
    />
  )
}
